import { ALL_DENIED, type ConsentChoice } from "@cmp/shared";

/**
 * Order matters: `default` must be called before any tag loads, and must be
 * dispatched synchronously at loader init. Any consent mutation after init
 * goes through `update`.
 */
export function installGtagShim(win: Window = window): void {
  win.dataLayer = win.dataLayer ?? [];
  if (typeof win.gtag !== "function") {
    win.gtag = function gtag(): void {
      // eslint-disable-next-line prefer-rest-params
      win.dataLayer.push(arguments);
    };
  }
}

export function setDefaultsDenied(win: Window = window): void {
  installGtagShim(win);
  win.gtag("consent", "default", {
    ...ALL_DENIED,
    wait_for_update: 500,
  });
}

export function updateConsent(choice: ConsentChoice, win: Window = window): void {
  installGtagShim(win);
  win.gtag("consent", "update", { ...choice });
  // Also push a generic dataLayer event so GTM can use a Custom Event
  // trigger (`cmp_consent`) to re-fire tags that were blocked by consent
  // on initial page load. Needed for Custom HTML tags (Meta Pixel,
  // LinkedIn pixel, etc.) that don't participate in Consent Mode's
  // automatic cookieless-redacted mode.
  win.dataLayer.push({ event: "cmp_consent", cmp_choice: { ...choice } });
}

export function dispatchReady(choice: ConsentChoice, win: Window = window): void {
  win.dispatchEvent(new CustomEvent("cmp:ready", { detail: { choice } }));
}

export function dispatchChange(choice: ConsentChoice, win: Window = window): void {
  win.dispatchEvent(new CustomEvent("cmp:change", { detail: { choice } }));
}
